<script setup lang="ts">
import { RouterView } from 'vue-router';
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import MaintenanceScreen from '@/components/MaintenanceScreen.vue';

// Maintenance takeover — set VITE_MAINTENANCE=true and redeploy during the
// migration window (Vite env is build-time), then remove it to restore access.
const maintenance = import.meta.env.VITE_MAINTENANCE === 'true';
</script>

<template>
  <MaintenanceScreen v-if="maintenance" />
  <template v-else>
    <RouterView />
    <Toast position="top-center" />
    <ConfirmDialog />
  </template>
</template>
